export default __webpack_public_path__ + "static/media/security-check.1180ad50.svg";